import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from 'src/app/tools/cookie-consent.service';
import { LEGAL_CONFIG } from 'src/app/tools/legal.config';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  config = LEGAL_CONFIG;
  private cookieConsentService = inject(CookieConsentService);
  currentYear = new Date().getFullYear();

  ouvrirBandeauCookies(): void {
    this.cookieConsentService.showBanner$.next();
  }
}
